module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick-8396a63215b35f304aec27a9ad265fb2.png";